import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Percent = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 40.105469 36.457031 C 40.105469 34.445312 38.472656 32.8125 36.457031 32.8125 C 34.445312 32.8125 32.8125 34.445312 32.8125 36.457031 C 32.8125 38.472656 34.445312 40.105469 36.457031 40.105469 C 38.472656 40.105469 40.105469 38.472656 40.105469 36.457031 Z M 38.480469 9.3125 C 39.089844 8.703125 40.078125 8.703125 40.6875 9.3125 C 41.296875 9.921875 41.296875 10.910156 40.6875 11.519531 L 11.519531 40.6875 C 10.910156 41.296875 9.921875 41.296875 9.3125 40.6875 C 8.703125 40.078125 8.703125 39.089844 9.3125 38.480469 Z M 17.1875 13.542969 C 17.1875 11.527344 15.554688 9.894531 13.542969 9.894531 C 11.527344 9.894531 9.894531 11.527344 9.894531 13.542969 C 9.894531 15.554688 11.527344 17.1875 13.542969 17.1875 C 15.554688 17.1875 17.1875 15.554688 17.1875 13.542969 Z M 43.230469 36.457031 C 43.230469 40.199219 40.199219 43.230469 36.457031 43.230469 C 32.71875 43.230469 29.6875 40.199219 29.6875 36.457031 C 29.6875 32.71875 32.71875 29.6875 36.457031 29.6875 C 40.199219 29.6875 43.230469 32.71875 43.230469 36.457031 Z M 20.3125 13.542969 C 20.3125 17.28125 17.28125 20.3125 13.542969 20.3125 C 9.800781 20.3125 6.769531 17.28125 6.769531 13.542969 C 6.769531 9.800781 9.800781 6.769531 13.542969 6.769531 C 17.28125 6.769531 20.3125 9.800781 20.3125 13.542969 Z M 20.3125 13.542969 "
        fill={color}
      />
    </svg>
  )
}
